"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
class HttpError extends Error {
    statusCode;
    type;
    instance;
    extensions;
    constructor(message, statusCode, type, instance, extensions) {
        super(message);
        this.statusCode = statusCode;
        this.type = type;
        this.instance = instance;
        this.extensions = extensions;
        this.name = this.constructor.name;
    }
    toResponse() {
        const body = {
            type: this.type,
            title: this.message,
            status: this.statusCode,
        };
        if (this.instance) {
            body.instance = this.instance;
        }
        if (this.extensions) {
            Object.assign(body, this.extensions);
        }
        return new Response(JSON.stringify(body), {
            status: this.statusCode,
            headers: { "Content-Type": "application/problem+json" },
        });
    }
}
exports.HttpError = HttpError;
